// ═══════════════════════════════════════════════════════════════════════
// IMPORTANT: This RESERVED list MUST match apps/build/shared/reserved-slugs.ts
// If you add a reserved slug, add it in BOTH places. Tracked as tech debt:
// future refactor → move to a shared workspace package.
// ═══════════════════════════════════════════════════════════════════════
const RESERVED = new Set([
  // Service / platform
  "admin", "api", "app", "auth", "dash", "dashboard", "docs", "help",
  "login", "logout", "mail", "my", "ops", "signin", "signup", "status",
  "support", "vault", "www", "account",
  // Marketing / brand
  "blog", "send",
  // Substrate / infra
  "brain", "build", "coolify", "inngest", "langfuse", "n8n", "phase1",
  "qdrant", "sense", "sloelabs", "substrate", "tech", "uptime",
  // Product lines
  "fit", "realty", "scout", "scoutbase-api", "sportnaa",
  // Tenant app itself
  "tenant",
]);

export function resolveTenant(hostname: string): string | null {
  if (!hostname) return null;
  const host = hostname.toLowerCase().split(":")[0];
  if (host === "localhost" || host === "127.0.0.1") return null;
  if (host === "sloelabs.com" || host === "www.sloelabs.com") return null;
  const prod = host.match(/^([a-z0-9-]+)\.sloelabs\.com$/);
  if (prod) { const s = prod[1]; return RESERVED.has(s) ? null : s; }
  const local = host.match(/^([a-z0-9-]+)\.localhost$/);
  if (local) { const s = local[1]; return RESERVED.has(s) ? null : s; }
  return null;
}

export function isReservedSlug(slug: string): boolean {
  return RESERVED.has(slug.toLowerCase());
}

export function isTenantHomepage(hostname: string): boolean {
  const host = hostname.toLowerCase().split(":")[0];
  return host === "tenant.sloelabs.com";
}
